module.exports = __webpack_public_path__ + "media/our-new-home.d65feccf.jpg";